import { render, staticRenderFns } from "./ProductDistributionTab.vue?vue&type=template&id=76646655&"
import script from "./ProductDistributionTab.vue?vue&type=script&lang=js&"
export * from "./ProductDistributionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn,QMenu,QList,QItem,QItemSection,QSeparator,QBtnToggle,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtn,QMenu,QList,QItem,QItemSection,QSeparator,QBtnToggle})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
